<template>
  <div class="i-team-multi-picker">
    <i-multi-picker
      :label-counter="$t('common.classesCounter')"
      :label="resolvedLabel"
      :placeholder="resolvedPlaceholder"
      :value="value"
      :fetch-options="fetchClassrooms"
      option-label="name"
      option-value="id"
      @input="$val => $emit('input',$val)"
    />
  </div>
</template>

<script>
import {listClassrooms} from "@/services/api/google/recovery/classroom/classroom";
import IMultiPicker from "@/components/common/forms/IMultiPicker.vue";

export default {
  name: 'IClassroomMultiPicker',
  components: {IMultiPicker},
  props: {
    value: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: "Classrooms"
    },
    placeholder: {
      type: String,
      default: 'Search all classrooms'
    },
  },

  computed: {
    resolvedLabel() {
      return this.label || this.$t('common.classes');
    },
    resolvedPlaceholder() {
      return this.placeholder || this.$t('common.searchAllClasses');
    }
  },

  data() {
    return {
      selected: null,
      classrooms: []
    }
  },

  methods: {
    fetchClassrooms({search}) {

      return listClassrooms({
        pagination: {
          pageNumber: 1,
          pageSize: 300,
          sortBy: 'name',
          sortDescending: false
        },
        search,
        filter: {
          "statuses": [
            1, 2, 4
          ]
        }
      })
        .then(({result}) => {
          return result
        })
    },
  },

}
</script>

<style lang="scss">
@import "IUserMultiPicker";
</style>
